import { getAuthTokenAsync } from "src/store/common";
import { Post, Meta } from "src/store/types";
import * as api from "./api";

interface ApiResponse {
  data: Post[];
  meta: Meta;
}

// fetch post list
export const fetchPostList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/post`,
    params,
  );
  return response;
};

// fetch reported posts
export const fetchReportedPosts = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/post/reported`,
    params,
  );
  return response;
};

// fetch post reports
export const fetchPostReports = async (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/post/reported/${pid}`,
  );
  return response;
};

// block/unblock post
export const blockUnblockPost = (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.get(`${process.env.REACT_APP_ADMIN_API_URL}/post/${pid}`);
};

// pin/unpin post
export const pinUnpinPost = (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.patch(`${process.env.REACT_APP_ADMIN_API_URL}/post/${pid}`);
};

// delete post
export const deletePost = (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.remove(`${process.env.REACT_APP_ADMIN_API_URL}/post/${pid}`);
};
